module.exports = __webpack_public_path__ + "img/9.cf613472.png";